export default "__VITE_ASSET__CsoZIRJ9__"